import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";
import "./App.css";
import LandingPage from "./LandingPage";
import SecondPage from "./SecondPage";
import SignupPage from "./SignupPage";
import LoginPage from "./LoginPage";
import PortalRouter from "./PortalRouter";
import MobilePortalPage from "./MobilePortalPage";
import SummaryPage from "./SummaryPage";
import ProtectedRoute from "./ProtectedRoute";
import TermsPage from "./TermsPage";
import ContactPage from "./ContactPage";
import BillingPage from "./BillingPage";
import SplashScreen from "./SplashScreen";

function DemoPortalEntry() {
  const [showSplash, setShowSplash] = useState(true);
  if (showSplash) {
    return <SplashScreen onComplete={() => setShowSplash(false)} durationMs={1800} />;
  }
  return <MobilePortalPage demoMode />;
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/second" element={<SecondPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/billing" element={<BillingPage />} />
      <Route path="/portal-demo" element={<DemoPortalEntry />} />
      <Route 
        path="/portal" 
        element={
          <ProtectedRoute>
            <PortalRouter />
          </ProtectedRoute>
        } 
      />
      <Route path="/summary" element={<SummaryPage />} />
    </Routes>
  );
}

export default App;
